import PropTypes from "prop-types"
import { forwardRef, useImperativeHandle, useRef } from "react"
import { Helmet } from "react-helmet-async"
// @mui
import { Box } from "@mui/material"
import { NotInPdf } from "lib/@components/pdf/not-in-pdf"
import { InPdf } from "lib/@components/pdf/in-pdf"
import { usePageScrollReset } from "minimals-template/components/page-scroll-reset"

// ----------------------------------------------------------------------

const Page = forwardRef(function Page({ children, title = "", meta, ...other }, ref) {
    const pageRef = useRef(null)
    useImperativeHandle(ref, () => pageRef.current)
    usePageScrollReset(pageRef)

    return (
        <>
            <Helmet>
                {title ? <title>{`${title} | Facilities-iQ`}</title> : <title>SFG20</title>}
                {meta}
            </Helmet>
            <NotInPdf>
                <Box
                    {...other}
                    ref={pageRef}
                    flex={1}
                    sx={{
                        ...other.sx,
                        overflowY: "auto",
                        overflowX: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        height: 1,
                    }}
                >
                    {children}
                </Box>
            </NotInPdf>
            <InPdf>
                <Box
                    ref={pageRef}
                    flex={1}
                    sx={{
                        overflowX: "hidden",
                    }}
                >
                    {children}
                </Box>
            </InPdf>
        </>
    )
})

Page.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    meta: PropTypes.node,
}

export default Page
